import { useGraphQLQuery } from '@betterment/graphql';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { PurposeContentCardDocument } from './graphql/purposeContentCard.generated';

import { ContentCardLocation } from '../../../../InAppMessages/data';
import MessageCard from '../../../../InAppMessages/MessageCard';

type Props = {
  location: ContentCardLocation;
};

export const ContentCardView: React.FC<Props> = ({ location }) => {
  const purposeId = useRequiredParam('purposeId');
  const { data } = useGraphQLQuery(PurposeContentCardDocument, { variables: { id: purposeId }, throwOnError: true });

  if (!data) return null;

  return <MessageCard location={location} goalId={data.purpose.legacyGoalId} />;
};
